webpackJsonp([84419135593297],{

/***/ 773:
/***/ (function(module, exports) {

	module.exports = [
	  {
	    "name": "Awesome Lists",
	    "key": "awesome-lists",
	    "aka": [
	      "nice lists",
	      "cool lists",
	      "pretty good lists"
	    ],
	    "description": "Lists of awesome things - JavaScript focus only.",
	    "count": 6,
	    "type": "PROJECT"
	  },
	  {
	    "name": "Bundlers",
	    "key": "bundlers",
	    "aka": [
	      "JavaScript bundlers",
	      "packagers"
	    ],
	    "description": "These are tools that transform JS and CSS. They are typically highly configurable and pluggable.",
	    "count": 4,
	    "type": "PROJECT"
	  },
	  {
	    "name": "Developer Tools",
	    "key": "devtools",
	    "aka": [
	      "dev tools"
	    ],
	    "description": "Tools used by developers while building JavaScript applications.",
	    "count": 18,
	    "type": "PROJECT"
	  },
	  {
	    "name": "Email Tools",
	    "key": "email-tools",
	    "aka": [
	      "other",
	      "unknown"
	    ],
	    "description": "Tools that are useful for creating, designing, or sending email in JavaScript.",
	    "count": 5,
	    "type": "PROJECT"
	  },
	  {
	    "name": "Error",
	    "key": "error",
	    "aka": [
	      "fail"
	    ],
	    "description": "Projects I wasn't able to parse for one reason or another.",
	    "count": 21,
	    "type": "PROJECT"
	  },
	  {
	    "name": "State Managers",
	    "key": "state-managers",
	    "aka": [
	      "flux libraries"
	    ],
	    "description": "These manage the state of your JavaScript application.",
	    "count": 26,
	    "type": "PROJECT"
	  },
	  {
	    "name": "Interesting",
	    "key": "interesting",
	    "aka": [
	      "other",
	      "unknown"
	    ],
	    "description": "These are things that I couldn't categorize but that I find interesting. Hopefully I find a place on the site for all of these things eventually.",
	    "count": 29,
	    "type": "PROJECT"
	  },
	  {
	    "name": "JavaScript Tutorials",
	    "key": "javascript-tutorials",
	    "aka": [
	      ""
	    ],
	    "description": "",
	    "count": 2,
	    "type": "PROJECT"
	  },
	  {
	    "name": "Linters",
	    "key": "linters",
	    "aka": [
	      "code formatters",
	      "beautifiers",
	      "prettifiers"
	    ],
	    "description": "Linters find potential errors and/or formatting inconsistencies in your code. Some will automatically fix your code for you.",
	    "count": 13,
	    "type": "PROJECT"
	  },
	  {
	    "name": "Loggers",
	    "key": "loggers",
	    "aka": [
	      "logging libraries"
	    ],
	    "description": "Utilities that help you log useful information to the console (or elsewhere). These are alternatives to \"console.log\".",
	    "count": 7,
	    "type": "PROJECT"
	  },
	  {
	    "name": "Networking Libraries",
	    "key": "networking-libraries",
	    "aka": [
	      "AJAX libraries"
	    ],
	    "description": "Tool that assist with making networking or AJAX calls",
	    "count": 9,
	    "type": "PROJECT"
	  },
	  {
	    "name": "React Components",
	    "key": "react-components",
	    "aka": [
	      "React Component Libraries",
	      "React UI Frameworks"
	    ],
	    "description": "The building blocks of React apps. These are components that you can use in your own apps.",
	    "count": 213,
	    "type": "PROJECT"
	  },
	  {
	    "name": "React Example Apps",
	    "key": "react-example-apps",
	    "aka": [
	      "react sample code",
	      "react sample apps"
	    ],
	    "description": "Open-source apps that use React.",
	    "count": 197,
	    "type": "PROJECT"
	  },
	  {
	    "name": "React Starter Projects",
	    "key": "react-starter-projects",
	    "aka": [
	      "react boilerplates",
	      "react starters",
	      "react seeds"
	    ],
	    "description": "Repositories that you can copy and modify to create your own React app.",
	    "count": 198,
	    "type": "PROJECT"
	  },
	  {
	    "name": "React Tutorials",
	    "key": "react-tutorials",
	    "aka": [
	      "react walkthroughs",
	      "react getting started",
	      "react guides"
	    ],
	    "description": "Articles that walk you through completing a task with React, step-by-step.",
	    "count": 7,
	    "type": "ARTICLE"
	  },
	  {
	    "name": "Static Site Generators",
	    "key": "static-site-generators",
	    "aka": [
	      "static site builder",
	      "static site framework"
	    ],
	    "description": "Tools that help you generate a static site.",
	    "count": 18,
	    "type": "PROJECT"
	  },
	  {
	    "name": "Style Libraries",
	    "key": "style-libraries",
	    "aka": [
	      "css processors",
	      "style utilities",
	      "stylers"
	    ],
	    "description": "Tools that assist you with applying CSS to your components or HTML.",
	    "count": 24,
	    "type": "PROJECT"
	  },
	  {
	    "name": "Test Utilities",
	    "key": "test-utilities",
	    "aka": [
	      "test frameworks",
	      "test tools"
	    ],
	    "description": "Tools that help you test your app.",
	    "count": 15,
	    "type": "PROJECT"
	  },
	  {
	    "name": "Utility Libraries",
	    "key": "utility-libraries",
	    "aka": [
	      "lodash alternatives",
	      "jquery alternatives",
	      "underscore alternatives"
	    ],
	    "description": "Each of these libraries contain many functions that are meant to help with a variety of common tasks in JavaScript.",
	    "count": 7,
	    "type": "PROJECT"
	  },
	  {
	    "name": "View Libraries",
	    "key": "view-libraries",
	    "aka": [
	      "UX Libraries",
	      "UX Frameworks"
	    ],
	    "description": "View libraries render your app in the browser. You provide some code or data in a format that is specific to the library, and the library handles rendering DOM elements and styles. All of these run within the browser, but some also run on the server.",
	    "count": 11,
	    "type": "PROJECT"
	  },
	  {
	    "name": "Learning Resources",
	    "key": "learning-resources",
	    "aka": [
	      "educational repositories"
	    ],
	    "description": "These are GitHub projects that assist in learning JavaScript or related tools.",
	    "count": 5,
	    "type": "PROJECT"
	  }
	]

/***/ }),

/***/ 775:
/***/ (function(module, exports, __webpack_require__) {

	const catalogue = __webpack_require__(773);
	
	module.exports = catalogue;


/***/ }),

/***/ 470:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _javascriptstuffDb = __webpack_require__(775);
	
	var _javascriptstuffDb2 = _interopRequireDefault(_javascriptstuffDb);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// These should be all the lists that are NOT marked as drafts.
	// It is a bit tricky to do this in an automatic (not hard-coded) way.
	// I also use this list to set the order in which things show up in the
	// home page topic list.
	var keys = ["react-components", "react-example-apps", "react-starter-projects", "style-libraries", "static-site-generators", "devtools", "state-managers", "linters", "view-libraries", "react-tutorials"];
	
	/**
	 * Filtered to only include the lists that I want to appear in search and on
	 * the home page.
	 */
	exports.default = keys.map(function (key) {
	  return _javascriptstuffDb2.default.find(function (item) {
	    return item.key === key;
	  });
	}).map(function (item) {
	  return _extends({}, item, { path: "/" + item.key + "/" });
	});
	module.exports = exports["default"];

/***/ }),

/***/ 159:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _CatDividerModule = __webpack_require__(297);
	
	var _CatDividerModule2 = _interopRequireDefault(_CatDividerModule);
	
	var _cat = __webpack_require__(339);
	
	var _cat2 = _interopRequireDefault(_cat);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CatDivider = function CatDivider() {
	  return _react2.default.createElement(
	    "div",
	    { className: _CatDividerModule2.default.root },
	    _react2.default.createElement("img", { className: _CatDividerModule2.default.cat, alt: "cat", width: 40, height: 40, src: _cat2.default })
	  );
	};
	exports.default = CatDivider;
	module.exports = exports["default"];

/***/ }),

/***/ 297:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"root":"src-components-common----CatDivider-module---root---a30p5","cat":"src-components-common----CatDivider-module---cat---2Q7Go"};

/***/ }),

/***/ 160:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(47);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HomeHelmet = function HomeHelmet(props) {
	  var url = "https://www.javascriptstuff.com" + props.path;
	  var name = "JavaScript Stuff";
	  var description = props.description;
	  var metaImagePath = "https://www.javascriptstuff.com/meta-home.png";
	
	  return _react2.default.createElement(
	    _reactHelmet.Helmet,
	    null,
	    _react2.default.createElement(
	      "title",
	      null,
	      name
	    ),
	    _react2.default.createElement("meta", { name: "title", content: name }),
	    _react2.default.createElement("meta", { name: "description", content: description }),
	    _react2.default.createElement("meta", { itemProp: "title", content: name }),
	    _react2.default.createElement("meta", { itemProp: "description", content: description }),
	    _react2.default.createElement("meta", { itemProp: "image", content: metaImagePath }),
	    _react2.default.createElement("meta", { name: "twitter:card", content: "summary" }),
	    _react2.default.createElement("meta", { name: "twitter:site", content: "@ahfarmer" }),
	    _react2.default.createElement("meta", { name: "twitter:creator", content: "@ahfarmer" }),
	    _react2.default.createElement("meta", { name: "twitter:title", content: name }),
	    _react2.default.createElement("meta", { name: "twitter:description", content: description }),
	    _react2.default.createElement("meta", { name: "twitter:image", content: metaImagePath }),
	    _react2.default.createElement("meta", { name: "og:title", content: name }),
	    _react2.default.createElement("meta", { name: "og:type", content: "article" }),
	    _react2.default.createElement("meta", { name: "og:url", content: url }),
	    _react2.default.createElement("meta", { name: "og:description", content: description }),
	    _react2.default.createElement("meta", { name: "og:site_name", content: "JavaScript Stuff" }),
	    _react2.default.createElement("meta", { name: "og:image", content: metaImagePath })
	  );
	};
	HomeHelmet.propTypes = {
	  path: _propTypes2.default.string,
	  description: _propTypes2.default.string
	};
	HomeHelmet.defaultProps = {
	  path: "/",
	  description: "Helping you find & learn modern JS tools w/ lists, guides, and articles."
	};
	exports.default = HomeHelmet;
	module.exports = exports["default"];

/***/ }),

/***/ 482:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Link = __webpack_require__(34);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _ListCardModule = __webpack_require__(641);
	
	var _ListCardModule2 = _interopRequireDefault(_ListCardModule);
	
	var _TopicIcon = __webpack_require__(343);
	
	var _TopicIcon2 = _interopRequireDefault(_TopicIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ListCard = function ListCard(_ref) {
	  var list = _ref.list;
	  return _react2.default.createElement(
	    _Link2.default,
	    { key: list.path, className: _ListCardModule2.default.root, to: list.path },
	    _react2.default.createElement(
	      "div",
	      { className: _ListCardModule2.default.titleRow },
	      _react2.default.createElement(
	        "div",
	        { className: _ListCardModule2.default.icon },
	        _react2.default.createElement(_TopicIcon2.default, { topicKey: list.key })
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: _ListCardModule2.default.title },
	        list.name
	      )
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: _ListCardModule2.default.row },
	      _react2.default.createElement(
	        "div",
	        { className: _ListCardModule2.default.description },
	        list.description
	      ),
	      list.count && _react2.default.createElement(
	        "div",
	        { className: _ListCardModule2.default.count },
	        list.count,
	        " ",
	        list.type.toLowerCase() + "s"
	      )
	    )
	  );
	};
	ListCard.propTypes = {
	  list: _propTypes2.default.shape({
	    path: _propTypes2.default.string.isRequired,
	    name: _propTypes2.default.string.isRequired,
	    description: _propTypes2.default.string,
	    count: _propTypes2.default.number,
	    type: _propTypes2.default.string
	  }).isRequired
	};
	exports.default = ListCard;
	module.exports = exports["default"];

/***/ }),

/***/ 641:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"root":"src-components-list----ListCard-module---root---1aIfy","titleRow":"src-components-list----ListCard-module---titleRow---ZZ_2L","icon":"src-components-list----ListCard-module---icon---HCK6G","title":"src-components-list----ListCard-module---title---3xhRP","description":"src-components-list----ListCard-module---description---1pvmt","count":"src-components-list----ListCard-module---count---3Ndm1"};

/***/ }),

/***/ 339:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 533:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ArticleStyle = __webpack_require__(42);
	
	var _ArticleStyle2 = _interopRequireDefault(_ArticleStyle);
	
	var _CatDivider = __webpack_require__(159);
	
	var _CatDivider2 = _interopRequireDefault(_CatDivider);
	
	var _CenterContent = __webpack_require__(17);
	
	var _CenterContent2 = _interopRequireDefault(_CenterContent);
	
	var _HomeHelmet = __webpack_require__(160);
	
	var _HomeHelmet2 = _interopRequireDefault(_HomeHelmet);
	
	var _listCatalogue = __webpack_require__(470);
	
	var _listCatalogue2 = _interopRequireDefault(_listCatalogue);
	
	var _Page = __webpack_require__(10);
	
	var _Page2 = _interopRequireDefault(_Page);
	
	var _listsModule = __webpack_require__(657);
	
	var _listsModule2 = _interopRequireDefault(_listsModule);
	
	var _ListCard = __webpack_require__(482);
	
	var _ListCard2 = _interopRequireDefault(_ListCard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ListsPage = function ListsPage() {
	  return _react2.default.createElement(
	    _Page2.default,
	    null,
	    _react2.default.createElement(_HomeHelmet2.default, {
	      path: "/lists/",
	      description: "Curated lists of libraries, tools, and articles: instantly find the best tool for your needs."
	    }),
	    _react2.default.createElement(
	      "div",
	      { className: _listsModule2.default.intro },
	      _react2.default.createElement(
	        _CenterContent2.default,
	        { wide: true },
	        _react2.default.createElement(
	          _ArticleStyle2.default,
	          null,
	          _react2.default.createElement(
	            "h1",
	            null,
	            "Lists"
	          ),
	          _react2.default.createElement(
	            "p",
	            null,
	            "Ever spent hours looking for the right dependency only to come up empty handed? Or worse - picked a library only to realize weeks later that you missed a better option?"
	          ),
	          _react2.default.createElement(
	            "p",
	            null,
	            "With hundreds of thousands of packages on npm, it can be difficult to find the best library. In fact, it can take all day just to find out what your options are."
	          ),
	          _react2.default.createElement(
	            "p",
	            null,
	            "That's where these lists come in: curated lists of libraries that are both sortable and filterable. Instantly see what packages are available. Then sort and filter to hone in on the perfect fit for your project."
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: _listsModule2.default.listOuter },
	      _react2.default.createElement(
	        _CenterContent2.default,
	        { wide: true },
	        _react2.default.createElement(
	          "div",
	          { className: _listsModule2.default.list },
	          _listCatalogue2.default.map(function (list) {
	            return _react2.default.createElement(_ListCard2.default, { key: list.path, list: list });
	          })
	        )
	      )
	    ),
	    _react2.default.createElement(_CatDivider2.default, null)
	  );
	};
	exports.default = ListsPage;
	module.exports = exports["default"];

/***/ }),

/***/ 657:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"intro":"src-pages----lists-module---intro---223N2","listOuter":"src-pages----lists-module---listOuter---3h3Ru","list":"src-pages----lists-module---list---hxieq"};

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-lists-js-206eee5605d79821a993.js